import { useIntl } from 'react-intl'
import { clsx } from 'clsx'

import type { ColorPickerProps } from './ColorPicker.types'
import { tagColorToHex } from './tagging.utils'

export const ColorPicker = (props: ColorPickerProps) => {
  const { colors, selectedColor, onChange } = props
  const intl = useIntl()

  return (
    <div aria-label={intl.formatMessage({ id: 'Tags_color_picker' })} className="ColorPicker" role="radiogroup">
      {colors.map(color => (
        <button
          key={color}
          aria-checked={color === selectedColor}
          aria-label={color}
          className={clsx('ColorPicker-swatch', {
            'ColorPicker-swatch--selected': color === selectedColor,
          })}
          onClick={() => onChange(color)}
          role="radio"
          style={{ '--swatch-color': tagColorToHex(color) } as React.CSSProperties}
          type="button"
        />
      ))}
    </div>
  )
}
